import { useState, useEffect } from "react";
import { Plus, Pencil, Power, Trash2 } from "lucide-react";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var CATEGORIAS = [["marca","Marca"],["tipo","Tipo"],["estado","Estado"]];

// Rediseno Bloque 3: no existe equivalente en sigte-prototipo.jsx -- ahi
// Marca/Tipo/Estado son constantes fijas en codigo (TIPOS_EQUIPO,
// MARCAS_EQUIPO, ESTADOS_EQUIPO, sigte-prototipo.jsx:925-927), nunca una
// pantalla editable. No hay nada que portar; diseno nuevo con el mismo
// lenguaje visual ya usado en Bloque 1/2 (rounded-2xl, border-neutral-200,
// bg-neutral-900, iconos lucide-react) y el mismo patron de pills del
// selector de normas del catalogo normativo del prototipo (linea 1950-1957).
export function SigteCatalogos() {
  var [catalogos,setCatalogos]=useState([]);
  var [loading,setLoading]=useState(true);
  var [tab,setTab]=useState("marca");
  var [nuevo,setNuevo]=useState("");
  var [err,setErr]=useState("");
  var [confirmDeleteId,setConfirmDeleteId]=useState(null);
  var [editingId,setEditingId]=useState(null);
  var [editingValor,setEditingValor]=useState("");

  function load(){
    sigteApiFetch("/catalogos").then(function(r){return r.json();}).then(function(d){
      setCatalogos(d.catalogos||[]); setLoading(false);
    });
  }
  useEffect(load,[]);

  async function add(){
    if(!nuevo.trim()){setErr("Escribe un valor.");return;}
    setErr("");
    try {
      await sigteApiFetchChecked("/catalogos",{method:"POST",body:JSON.stringify({categoria:tab,valor:nuevo.trim()})});
      setNuevo(""); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  async function toggleActivo(c){
    try {
      await sigteApiFetchChecked("/catalogos/"+c.id,{method:"PUT",body:JSON.stringify({activo:!c.activo})});
      load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function startEdit(c){ setEditingId(c.id); setEditingValor(c.valor); setErr(""); }
  async function saveEdit(c){
    if(!editingValor.trim()){setErr("El valor no puede estar vacío.");return;}
    try {
      await sigteApiFetchChecked("/catalogos/"+c.id,{method:"PUT",body:JSON.stringify({valor:editingValor.trim()})});
      setEditingId(null); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  async function del(c){
    try {
      await sigteApiFetchChecked("/catalogos/"+c.id,{method:"DELETE"});
      setConfirmDeleteId(null); load();
    } catch(e) {
      setErr(e.message); setConfirmDeleteId(null);
    }
  }

  if(loading) return <p className="text-sm text-neutral-500">Cargando...</p>;

  var rows = catalogos.filter(function(c){return c.categoria===tab;});

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight text-neutral-900">Catálogos</h1>
        <p className="mt-1 text-sm text-neutral-500">Marca, tipo y estado de equipos.</p>
      </header>

      <div className="inline-flex flex-wrap rounded-xl border border-neutral-200 bg-white p-1">
        {CATEGORIAS.map(function(t){
          var activo = tab===t[0];
          return (
            <button key={t[0]} onClick={function(){setTab(t[0]);setErr("");setEditingId(null);}}
              className={"rounded-lg px-3.5 py-2 text-sm font-medium transition-colors " + (activo ? "bg-neutral-900 text-white" : "text-neutral-500 hover:text-neutral-900")}>
              {t[1]}
            </button>
          );
        })}
      </div>

      {err?(
        <div className="flex items-center justify-between rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700">
          <span>{err}</span>
          <button onClick={function(){setErr("");}} className="font-medium">×</button>
        </div>
      ):null}

      <div className="rounded-2xl border border-neutral-200 bg-white p-5">
        <div className="flex flex-wrap gap-2">
          <input value={nuevo} onChange={function(e){setNuevo(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")add();}}
            placeholder={"Nuevo valor de "+tab}
            className="min-w-0 flex-1 rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-900 placeholder-neutral-400 focus:border-neutral-400 focus:outline-none"/>
          <button onClick={add} className="inline-flex items-center gap-1.5 rounded-xl bg-neutral-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-700">
            <Plus size={16}/> Agregar
          </button>
        </div>
      </div>

      <div className="overflow-hidden rounded-2xl border border-neutral-200 bg-white">
        {rows.map(function(c,i){
          return (
            <div key={c.id} className={"flex flex-wrap items-center justify-between gap-3 px-5 py-4 " + (i>0 ? "border-t border-neutral-100" : "")}>
              {editingId===c.id?(
                <input value={editingValor} onChange={function(e){setEditingValor(e.target.value);}} onKeyDown={function(e){if(e.key==="Enter")saveEdit(c);}}
                  className="min-w-0 max-w-xs flex-1 rounded-lg border border-neutral-200 bg-white px-3 py-2 text-sm text-neutral-900 focus:border-neutral-400 focus:outline-none"/>
              ):(
                <p className={"truncate text-sm font-medium " + (c.activo ? "text-neutral-900" : "text-neutral-400")}>{c.valor}{!c.activo?" (inactivo)":""}</p>
              )}
              <div className="flex flex-wrap items-center gap-1">
                {editingId===c.id?(
                  <button onClick={function(){saveEdit(c);}} className="rounded-xl bg-neutral-900 px-3.5 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-700">Guardar</button>
                ):(
                  <button onClick={function(){startEdit(c);}} title="Editar" className="rounded-lg p-1.5 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700"><Pencil size={15}/></button>
                )}
                <button onClick={function(){toggleActivo(c);}} title={c.activo?"Desactivar":"Activar"}
                  className={"rounded-lg p-1.5 hover:bg-neutral-100 " + (c.activo ? "text-neutral-400 hover:text-neutral-700" : "text-emerald-500 hover:text-emerald-600")}>
                  <Power size={15}/>
                </button>
                {confirmDeleteId===c.id?(
                  <div className="flex items-center gap-2 rounded-xl bg-red-50 px-3 py-2">
                    <span className="text-xs text-red-700">¿Eliminar?</span>
                    <button onClick={function(){del(c);}} className="text-xs font-medium text-red-700 underline">Sí</button>
                    <button onClick={function(){setConfirmDeleteId(null);}} className="text-xs font-medium text-neutral-500">No</button>
                  </div>
                ):(
                  <button onClick={function(){setConfirmDeleteId(c.id);}} title="Eliminar" className="rounded-lg p-1.5 text-neutral-400 hover:bg-red-50 hover:text-red-600"><Trash2 size={15}/></button>
                )}
              </div>
            </div>
          );
        })}
        {rows.length===0?<p className="px-5 py-8 text-center text-sm text-neutral-400">No hay valores en este catálogo.</p>:null}
      </div>
    </div>
  );
}
